import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createLinkReference,
  deleteLinkReferenceById,
  importLinkReference,
  searchLinkReference,
  updateLinkReference,
} from "../api/linkreferenceApi";
import { handleApiError } from "../api/InstanceApi";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";

export const useLinkFerence = (searchParams) => {
  const intl = useIntl();
  const {
    data: linkreference,
    isLoading: linkreferenceLoading,
    error: linkreferenceError,
  } = useQuery({
    queryKey: [
      "linkreference-data",
      searchParams?.page,
      searchParams?.limit,
      searchParams?.name,
    ],
    queryFn: () => searchLinkReference(searchParams),
    staleTime: 0,
  });
  const deleteMutation = useMutation({
    mutationFn: async (id) => {
      return await toast.promise(deleteLinkReferenceById(id), {
        pending: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.DELETING' })}`;
          },
        },
        success: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.DELETED' })}`;
          },
        },
        error: {
          render({ data }) {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.DELETE_ERROR' })}`;
          },
        },
      });
    },
    onError: (data) => handleApiError(data),
  });

  const importMutation = useMutation({
    mutationFn: async (file) => {
      return await toast.promise(importLinkReference(file), {
        pending: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.IMPORTING' })}`;
          },
        },
        success: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.IMPORTED' })}`;
          },
        },
        error: {
          render({ data }) {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.IMPORT_ERROR' })}`;
          },
        },
      });
    },
    onError: (data) => handleApiError(data),
  });

  const createMutation = useMutation({
    mutationFn: async (data) => {
      return await toast.promise(createLinkReference(data), {
        pending: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.CREATING' })}`;
          },
        },
        success: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.CREATED' })}`;
          },
        },
        error: {
          render({ data }) {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.CREATE_ERROR' })}`;
          },
        },
      });
    },
    onError: (data) => handleApiError(data),
  });

  const updateMutation = useMutation({
    mutationFn: async (data) => {
      return await toast.promise(updateLinkReference(data), {
        pending: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.UPDATING' })}`;
          },
        },
        success: {
          render() {
            return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.UPDATED' })}`;
          },
        },
        error: {
          render({ data }) {
              return `${intl.formatMessage({ id: 'AGENTS.LINK_REFERENCE_DATA.UPDATE_ERROR' })}`;
          },
        },
      });
    },
    onError: (data) => handleApiError(data),
  });
  return {
    linkreference,
    linkreferenceLoading,
    linkreferenceError,
    deleteLinkReferenceAsync: deleteMutation.mutateAsync,
    importLinkReferenceAsync: importMutation.mutateAsync,
    createLinkReferenceAsync: createMutation.mutateAsync,
    updateLinkReferenceAsync: updateMutation.mutateAsync,
  };
};
